import { insTypeOrders } from '@/base/config.js'
import { normalizeKeys } from 'base/config'
import { sexToString } from 'common/js/common'
import { formatCalculateData, formatTenThousand, formatDisplayData } from 'common/js/format'
import { tempToFill } from 'components/liability/common'

export function buildMapData(data, options = {}) {
  const { resultData, liabilities, categorySortList } = data
  const { categoryKey } = options
  if (!resultData || !liabilities) {
    return
  }

  const { title, personData, productGroupList, totalBaof, theme } = resultData
  const calInsuranceData = formatCalculateData(resultData, normalizeKeys).calData
  const insuredInfo   = personData.personOrderList.find(item => item.key === 'insuredInfo')
  const prodOrderList = productGroupList[0].prodOrderList
  const { sex, age } = insuredInfo
  const _totalBaof = formatTenThousand(totalBaof)

  const productData = {
    label: `被保人 ${sexToString(sex)} ${age}岁 首年总保费${_totalBaof}元`,
    label2: '保障 保险期间/交费期 首年保费',
    id: '0-0',
    isPerson: true,
    vGap: 20,
    insurances: []
  }
  productData.insurances = buildProductInfo(prodOrderList)
  function parseLiability (liabilities) {
    if (!(liabilities && liabilities.length)) {
      return
    }
    liabilities.forEach(prodLib => {
      const { productId, insuranceLiabilities } = prodLib
      const parsedDesc1Cfg = {
        productId,
        data: calInsuranceData
      }
      if (!(insuranceLiabilities && insuranceLiabilities.length)) {
        return
      }
      insuranceLiabilities.forEach(insLib => {
        const { liabilities : insLiabilities } = insLib
        if (!(insLiabilities && insLiabilities.length)) {
          return
        }
        insLiabilities.forEach(oneLib => {
          const keys = ['headline', 'description1', 'description2']
          keys.forEach(k => {
            oneLib[k] = tempToFill({
              ...parsedDesc1Cfg,
              temp: oneLib[k],
            }, formatDisplayData)
          })
        })
      })
    })
  }
  function buildProductInfo (prodList) {
    if (!(prodList && prodList.length)) {
      return []
    }
    const insurances = []
    prodList.forEach(prod => {
      if (prod.mulInsOrderList && prod.mulInsOrderList.length) {
        prod.mulInsOrderList.forEach(ins => {
          insurances.push({
            label: `${ins.name || ''} ${ins.baoeDesc || ''} ${ins.iDurationDesc || ''}/${ins.pPeriodDesc || ''} ${ins.baofDesc || ''}`,
            id: `${productData.id}-${insurances.length + 1}`,
            color: '#5AD8A6',
          })
        })
      }
    })
    return insurances
  }
  function buildLiabilityInfo (liabilityList) {
    const allLiabilities = []
    if (!(liabilityList && liabilityList.length)) {
      return allLiabilities
    }

    const allInsurances = liabilityList.reduce((accumulate, current) => {
      return accumulate.concat(...(current.insuranceLiabilities || []))
    }, []).filter(l => !!l)
    const allInsuranceLiabilities = liabilityList.reduce((accumulate, current) => {
      const insLiabilities = current.insuranceLiabilities.map(ins => ins.liabilities)
      return accumulate.concat(...(insLiabilities || []))
    }, []).filter(l => !!l)

    let liabilitysort = []
    if (categoryKey === 'categoryId') {
      const categoryOrder = categorySortList || insTypeOrders[theme] || insTypeOrders.normal
      const categoryIds = categoryOrder.filter(t => allInsuranceLiabilities.find((liab) => t === liab.categoryId))
      liabilitysort = categoryIds.map(id => {
        const temp = allInsuranceLiabilities.find((liab) => id === liab.categoryId)
        return {
          [categoryKey]: temp.categoryId,
          categoryName: temp.categoryName
        }
      })
    } else {
      liabilitysort = allInsurances.map(ins => ({
        [categoryKey] : ins.insuranceId,
        categoryName: ins.insuranceName
      }))
    }

    liabilitysort.forEach(sortEle => {
      allInsuranceLiabilities.forEach((liab, index) => {
        if (liab[categoryKey] !== sortEle[categoryKey]) {
          return
        }
        const keys = ['description1', 'description2']
        keys.forEach(k => {
          if (liab[k]) {
            liab[k] = liab[k].replace(/^((\n)|(\<br\>)|(\<\/br\>)|(\<br\/\>))/, '')
            liab[k] = liab[k].replace(/((\n)|(\<br\>)|(\<\/br\>)|(\<br\/\>))$/, '')
          }
        })
        if (!liab.description1 && !liab.description2) {
          return
        }

        allLiabilities.push({
          id: `0-${index + 1}`,
          depth: 1,
          liabId: liab.id,
          [categoryKey]: sortEle[categoryKey],
          categoryName: sortEle.categoryName || '',
          headline: liab.headline,
          description1: liab.description1,
          description2: liab.description2,
        })
      })
    })
    liabilitysort.forEach(ele => {
      const elementsOfTheCategory = allLiabilities.filter(liab => liab[categoryKey] === ele[categoryKey])
      if (elementsOfTheCategory[0]) {
        elementsOfTheCategory[0].isFirstElementOfTheCategory = true
      }
      if (elementsOfTheCategory.length && elementsOfTheCategory[elementsOfTheCategory.length - 1]) {
        elementsOfTheCategory[elementsOfTheCategory.length - 1].isLastElementOfTheCategory = true
      }
    })

    return allLiabilities
  }

  parseLiability(liabilities)
  const chartTitle = prodOrderList && prodOrderList.length > 1 ? `${insuredInfo.name || (['男', '女'][insuredInfo.sex - 1] + insuredInfo.age + '岁')}综合保障方案` : title
  const rawData = {
    label: chartTitle,
    id: '0',
    depth: 0,
    children: [
      productData,
      ...(buildLiabilityInfo(liabilities))
    ]
  }
  return rawData
}

export const BASE_CONFIG = {
  fontSize: 14,
  fontSize12: 12,
  lineHeight: 1.35,
  margin: 10,
  padding: 10,
  borderRadius: 8,
  nodeWidth: 200,
};

export const THEME_COLORS = {
  // colors: ['#5B8FF9', '#F6BD16', '#5AD8A6', '#945FB9', '#E86452', '#6DC8EC', '#FF99C3', '#1E9493', '#FF9845', '#5D7092'],
  colors: ['#289656', '#f1c857', '#f09852', '#e9555a', '#3581ea', '#9a51dd', '#30ae63', '#349dd9', '#c868ea', '#2ad8d6'],
  rootColor: '#fff',
  rootBgColor: '#1f2767',
  productColor: '#420000',
  productBgColor1: '#fc8252',
  productBgColor2: '#fee5de',
  categoryBgColor: '#d2d5df'
}

export function autoWrapText (g6, str, params = {}) {
  const { maxWidth = 200, fontSize = 14, lineHeight = 1.35 } = params
  const { Util } = g6
  const result = {
    html: str || '',
    text: '',
    size: 0,
    height: 0
  }
  if (!str) {
    return result
  }

  // 匹配<br> 标签的正则：/(\<br\>)|(\<\/br\>)|(\<br\/\>)/
  const toH5Rules = [
    { regexp: /(\n)+/ig, str: '\n' },
    { regexp: /\n/ig, str: '<br>' },
    { regexp: /((\<br\>)|(\<\/br\>)|(\<br\/\>))+/ig, str: '<br>' },
    { regexp: /((\<br\>)|(\<\/br\>)|(\<br\/\>))$/ig, str: '' },
  ]
  toH5Rules.forEach(r => {
    result.html = result.html.replace(r.regexp, r.str)
  })

  let targetStr = str
  const toRawTextRules = [
    { regexp: /\<span\>(.*)\<\/span\>/ig, str: '$1' },
    { regexp: /(\<br\>)|(\<\/br\>)|(\<br\/\>)/ig, str: '\n' },
    { regexp: /(\n)+/ig, str: '\n' },
    { regexp: /(\n)$/ig, str: '' },
  ]
  toRawTextRules.forEach(r => {
    targetStr = targetStr.replace(r.regexp, r.str)
  })
  if (!targetStr) {
    return result
  }

  let size = 0
  const strLines = targetStr.split('\n')
  strLines.forEach((line, i, arr) => {
    let currentWidth = 0;
    const wrapIndex = []
    const strArr = line.split('')
    strArr.forEach((letter, i) => {
      currentWidth += Util.getLetterWidth(letter, fontSize);
      if (currentWidth > maxWidth) {
        wrapIndex.push(i)
        currentWidth = 0
      }
    });
    wrapIndex.forEach(value => {
      strArr.splice(value, 0, '\n')
    })
    size += (strArr.filter(e => e === '\n').length + 1)
    arr[i] = strArr.join('')
  })

  result.text = strLines.join('')
  result.size = size
  result.height = size * fontSize * lineHeight
  return result
}

export function calculateNodeHeight (g6, node, config = BASE_CONFIG) {
  const _autoWrapText = autoWrapText.bind(null, g6)
  const { fontSize12, margin, padding, nodeWidth, rootNodeWidth } = config
  if (!node) {
    return 0
  }
  const {
    depth,
    isPerson,
    isFirstElementOfTheCategory,
    isLastElementOfTheCategory,
    label,
    label2,
    insurances,
    categoryName,
    headline,
    description1,
    description2
  } = node

  node.categoryTitleHeight = 0
  node.titleHeight = 0
  node.vGap = 5
  if (isLastElementOfTheCategory) {
    node.vGap += margin
  }

  let height = 0
  if (node.depth === 0) {
    const textWrap = _autoWrapText(node.label, {
      maxWidth: (rootNodeWidth || nodeWidth) - padding * 2
    })
    height = textWrap.height + padding * 2
  }

  if (isPerson) {
    const labelList = [label, label2]
    labelList.forEach(l => {
      const textWrap = _autoWrapText(l, {
        maxWidth: nodeWidth - padding * 2,
        fontSize: fontSize12
      })
      height += (textWrap.height + padding * 2)
    })
    if (insurances && insurances.length) {
      insurances.map(ins => {
        const insTextWrap = _autoWrapText(ins.label, {
          maxWidth: nodeWidth - padding * 2,
          fontSize: fontSize12
        })
        height += insTextWrap.height + margin + padding
      })
    }
  }
  if (depth === 1) {
    const categoryWrap = _autoWrapText(categoryName, {
      maxWidth: nodeWidth - padding * 2
    })
    if (isFirstElementOfTheCategory && categoryWrap.size) {
      node.categoryTitleHeight = categoryWrap.height + padding
      height += node.categoryTitleHeight + margin
    }
    const titleWrap = _autoWrapText(headline, {
      maxWidth: nodeWidth - padding * 2
    })
    if (titleWrap.size) {
      node.titleHeight = titleWrap.height + padding
      height += node.titleHeight + margin * 2
    }
    const descWrap1 = _autoWrapText(description1, {
      maxWidth: nodeWidth - padding * 2
    })
    if (descWrap1.size) {
      height += (descWrap1.height + padding * 2)
    }
    const descWrap2 = _autoWrapText(description2, {
      maxWidth: nodeWidth - padding * 2,
      fontSize: fontSize12
    })
    if (descWrap2.size) {
      height += (descWrap2.height + (descWrap1.size ? margin / 2 : 0) + padding)
    }
  }
  return height
}

export function createTree(G6, options = {}) {
  const { Util } = G6;
  const { resultData : sourceData, liabilityShowType, afterlayout } = options
  const categoryKey = liabilityShowType === 1 ? 'insuranceId' : 'categoryId' // 分类的关键字：categoryId-按责任 insuranceId-按险种
  const _autoWrapText = autoWrapText.bind(null, G6)
  const _calculateNodeHeight = calculateNodeHeight.bind(null, G6)
  G6.registerNode('indentedRoot', {
    draw(model, group) {
      const { fontSize, padding, nodeWidth } = BASE_CONFIG
      const { rootColor, rootBgColor } = THEME_COLORS
      const { label, nodeHeight } = model
      const rectShape = group.addShape('rect', {
        attrs: {
          x: -30,
          y: 0,
          width: 0,
          height: nodeHeight,
          fill: rootBgColor,
          radius: 2,
          lineWidth: 2
        },
        name: 'root-rect-shape'
      })

      if (label) {
        const textWrap = _autoWrapText(label, {
          maxWidth: nodeWidth - padding * 2
        })
        const text = group.addShape('text', {
          attrs: {
            text: textWrap.text,
            fill: rootColor,
            fontSize,
            x: -15,
            y: nodeHeight / 2,
            textAlign: 'left',
            textBaseline: 'middle',
          },
          name: 'root-text-shape'
        });
        const textBBox = text.getBBox();
        const textWidth = textBBox.width + 30;
        rectShape.attr({
          width: textWidth
        })
      }

      return rectShape;
    },
    update: undefined
  });

  G6.registerNode('indentedNode', {
    drawCategory (model, group) {
      const { fontSize, padding, borderRadius, nodeWidth } = BASE_CONFIG
      const { rootColor, rootBgColor, categoryBgColor } = THEME_COLORS
      const { isFirstElementOfTheCategory, categoryName, categoryTitleHeight, categoryBorderHeight } = model

      if (!isFirstElementOfTheCategory) {
        return
      }
      group.addShape('rect', {
        attrs: {
          x: -20,
          y: categoryTitleHeight - 1,
          width: nodeWidth + 40,
          height: categoryBorderHeight,
          radius: borderRadius,
          fill: categoryBgColor,
          opacity: 0.5
        },
        name: 'category-bg-rect-shape'
      });
      group.addShape('rect', {
        attrs: {
          x: -20,
          y: categoryTitleHeight - 1,
          width: nodeWidth + 40,
          height: categoryBorderHeight,
          radius: borderRadius,
          lineWidth: 2,
          lineDash: [9, 3],
          stroke: rootBgColor,
        },
        name: 'category-border-rect-shape'
      });
      if (categoryName) {
        const textWrap = _autoWrapText(categoryName)
        const textShape = group.addShape('text', {
          attrs: {
            text: textWrap.text,
            fill: rootColor,
            fontSize,
            x: 10,
            y: categoryTitleHeight / 2 + 2,
            textAlign: 'left',
            textBaseline: 'middle',
          },
          name: 'category-text-shape'
        });
        const textBBox = textShape.getBBox();
        const textWidth = textBBox.width + padding * 2;

        const rectAttrs = {
          x: 0,
          y: 0,
          width: textWidth,
          height: categoryTitleHeight,
          radius: [borderRadius, borderRadius, 0, 0],
          fill: rootBgColor
        };
        group.addShape('rect', {
          attrs: rectAttrs,
          name: 'category-text-rect-shape'
        });
        textShape.toFront()
      }
    },
    drawHeadline (model, group) {
      const { fontSize, margin, padding, borderRadius, nodeWidth } = BASE_CONFIG
      const { rootColor, rootBgColor } = THEME_COLORS
      const { nodeHeight, categoryTitleHeight, titleHeight, headline } = model;

      if (!headline) {
        return
      }
      const categoryMarginTop = categoryTitleHeight ? categoryTitleHeight + margin : 0
      const bgTopDistance = categoryMarginTop + titleHeight
      group.addShape('rect', {
        attrs: {
          x: -10,
          y: bgTopDistance - 1,
          width: nodeWidth + padding * 2,
          height: nodeHeight - bgTopDistance,
          radius: borderRadius,
          lineWidth: 2,
          lineDash: [9, 3],
          stroke: rootBgColor
        },
        name: 'headline-bg-rect-shape'
      });

      const textWrap = _autoWrapText(headline)
      const titleShape = group.addShape('text', {
        attrs: {
          text: textWrap.text,
          fill: rootColor,
          fontSize,
          x: 10,
          y: categoryMarginTop + titleHeight / 2 + 2,
          textAlign: 'left',
          textBaseline: 'middle',
        },
        name: 'headline-text-shape'
      });
      const titleBBox = titleShape.getBBox();
      const textWidth = titleBBox.width + padding * 2;
      const titleRectShape = group.addShape('rect', {
        attrs: {
          x: 0,
          y: categoryMarginTop,
          width: textWidth,
          height: titleHeight,
          radius: [borderRadius, borderRadius, 0, 0],
          fill: rootBgColor
        },
        name: 'headline-rect-shape'
      });
      titleShape.toFront()
      return titleRectShape
    },
    drawPerson (model, group) {
      const { fontSize12, lineHeight, padding, borderRadius, nodeWidth } = BASE_CONFIG
      const { productColor, productBgColor1, productBgColor2 } = THEME_COLORS
      const { isPerson, nodeHeight, label, label2 } = model;
      if (!isPerson) {
        return
      }

      let domHTML1 = ''
      const labelList = [label, label2]
      labelList.forEach(l => {
        const textWrap = _autoWrapText(l, {
          maxWidth: nodeWidth + 20,
          fontSize: fontSize12
        })
        domHTML1 += `<div style="padding: ${padding}px; line-height: ${lineHeight}; background: ${productBgColor1}; border-bottom: 1px solid rgba(255, 255, 255, 0.5);">
          ${textWrap.html}
        </div>`
      })
      let domHTML2 = `<div style="padding: ${padding / 2}px ${padding / 2}px 0; line-height: ${lineHeight}; color: ${productColor}; background: ${productBgColor2};">`
      model.insurances.forEach(ins => {
        const textWrap = _autoWrapText(ins.label, {
          maxWidth: nodeWidth + 20,
          fontSize: fontSize12
        })
        domHTML2 += `
          <span style="display: inline-block; padding: ${padding / 2}px; margin-bottom: ${padding / 2}px; background: #fcf4f2; border-radius: ${borderRadius}px;">
            ${textWrap.html}
          </span>
        `
      })
      domHTML2 += '</div>'

      const domHTML = `<div style="font-size: ${fontSize12}px; line-height: ${lineHeight};">
        ${domHTML1}
        ${domHTML2}
      </div>`
      const domShape = group.addShape('dom', {
        attrs: {
          width: nodeWidth + 20,
          height: nodeHeight,
          html: domHTML
        },
        name: 'dom-shape'
      });
      return domShape
    },
    drawLiability (model, group) {
      const { fontSize, fontSize12, lineHeight, margin, padding, borderRadius, nodeWidth } = BASE_CONFIG
      const { isPerson, depth, nodeHeight, categoryTitleHeight, titleHeight, description1, description2, mainColor } = model;
      if (isPerson) {
        return
      }
      if (depth !== 1) {
        return
      }

      let marginTop = 0
      if (categoryTitleHeight) {
        marginTop += (categoryTitleHeight + margin)
      }
      if (titleHeight) {
        marginTop += (titleHeight + margin)
      }

      let domHTML1 = ''
      const textWrap01 = _autoWrapText(description1, {
        maxWidth: nodeWidth - padding * 2
      })
      if (textWrap01.html) {
        domHTML1 += `<div style="margin-bottom: ${description2 ? margin / 2 : 0}px; padding: ${padding}px; color: white; background: ${mainColor}; border-radius: ${borderRadius}px;">
          ${textWrap01.html}
        </div>`
      }

      let domHTML2 = ''
      const textWrap02 = _autoWrapText(description2, {
        maxWidth: nodeWidth - padding * 2,
        fontSize: fontSize12
      })
      if (textWrap02.html) {
        domHTML2 += `<p style="margin: 0; padding: ${padding / 2}px ${padding}px; font-size: ${fontSize12}px; line-height: ${lineHeight}; background: white; border-radius: ${borderRadius}px;">
          ${textWrap02.html}
        </p>`
      }

      let domHTML = `
        <div style="line-height: ${lineHeight}; font-size: ${fontSize}px;">
          ${domHTML1}
          ${domHTML2}
        </div>
      `
      const domShape = group.addShape('dom', {
        attrs: {
          y: marginTop,
          width: nodeWidth,
          height: nodeHeight,
          html: domHTML
        },
        name: 'dom-shape'
      });

      // debug：给整个节点加边框
      // group.addShape('rect', {
      //   attrs: {
      //     x: 0,
      //     y: 0,
      //     width: nodeWidth,
      //     height: nodeHeight,
      //     lineWidth: 1,
      //     stroke: mainColor
      //   },
      //   name: 'node-border-rect-shape'
      // });
      return domShape
    },
    draw(model, group) {
      this.drawCategory(model, group)
      this.drawHeadline(model, group)
      const personDraw = this.drawPerson(model, group)
      const liabilityDraw = this.drawLiability(model, group)
      return personDraw || liabilityDraw
    }
  });

  G6.registerEdge('indentedEdge', {
    afterDraw: (cfg, group) => {
      const sourceNode = cfg.sourceNode.getModel();
      const targetNode = cfg.targetNode.getModel();
      const color = sourceNode.mainColor || targetNode.mainColor || cfg.color || '#000';
      const keyShape = group.get('children')[0];
      keyShape.attr({
        stroke: color,
        lineWidth: 3 // branchThick
      });
      group.toBack();
    },
    getControlPoints: (cfg) => {
      const { margin } = BASE_CONFIG
      const { startPoint, endPoint } = cfg
      endPoint.y += (endPoint.description1 ? 13 : 6)
      if (endPoint.categoryTitleHeight) {
        endPoint.y += (endPoint.categoryTitleHeight + margin)
      }
      if (endPoint.titleHeight) {
        endPoint.y += (endPoint.titleHeight + margin)
      }
      return [
        startPoint,
        {
          x: startPoint.x,
          y: endPoint.y,
        },
        endPoint
      ];
    },
    update: undefined
  }, 'polyline');

  const dataTransform = (data) => {
    if (!data) {
      return data
    }
    const { margin } = BASE_CONFIG
    const changeData = (d, level = 0) => {
      const data = {
        ...d,
        type: d.depth === 0 ? 'indentedRoot' : 'indentedNode',
        nodeHeight: _calculateNodeHeight(d, BASE_CONFIG)
      };

      if (d.children) {
        data.children = d.children.map((child) => changeData(child, level + 1));
      }
      if (data.children && data.children.length) {
        data.children.forEach((subtree, i) => {
          subtree.mainColor = THEME_COLORS.colors[i % THEME_COLORS.colors.length];
          Util.traverseTree(subtree, child => {
            child.mainColor = THEME_COLORS.colors[i % THEME_COLORS.colors.length];
            return true;
          })
        });
      }
      return data;
    };

    Util.traverseTree(data, child => {
      child.nodeHeight = _calculateNodeHeight(child, BASE_CONFIG)
      return true;
    })
    Util.traverseTree(data, child => {
      if (!child.children) {
        return
      }
      const firstElementsOfTheCategory = child.children.filter(c => c.isFirstElementOfTheCategory)
      firstElementsOfTheCategory.forEach(ele => {
        ele.categoryHeight = 0
        child.children.filter(c => c[categoryKey] === ele[categoryKey]).forEach(c => {
          ele.categoryHeight += (c.nodeHeight + c.vGap * 2)
        })
        ele.categoryBorderHeight = ele.categoryHeight - ele.categoryTitleHeight - margin * 2
      })
      return true;
    })
    return changeData(data);
  };

  const wrapperDom = document.querySelector('#IndentTree')
  const wrapperDomWidth = wrapperDom && wrapperDom.offsetWidth > 0 ? wrapperDom.offsetWidth : 375
  const wrapperDomHeight = wrapperDom && wrapperDom.offsetHeight > 0 ? wrapperDom.offsetHeight : (window.innerHeight || document.documentElement.clientHeight)
  const graphConfig = {
    container: 'IndentTree',
    renderer: 'svg',
    width: wrapperDomWidth,
    height: wrapperDomHeight,
    fitView: true,
    fitCenter: true,
    minZoom: 0.01,
    layout: {
      type: 'indented',
      direction: 'LR',
      indent: 40,
      getHeight: (d) => d.nodeHeight,
      getVGap: (d) => d.vGap,
    },
    defaultEdge: {
      type: 'indentedEdge',
      style: {
        lineWidth: 2,
        radius: 16,
      },
    },
  }

  const tree = new G6.TreeGraph(graphConfig);
  const mapData = buildMapData(sourceData, {
    categoryKey
  })
  if (!mapData) {
    return
  }
  const treeData = dataTransform(mapData)
  tree.data(treeData);
  tree.render();
  tree.on('afterlayout', () => {
    if (afterlayout) {
      afterlayout(tree)
    }
  })
  return tree
}
